export default __webpack_public_path__ + "static/media/Background_00125.726c6238.png";